export default "__VITE_ASSET__C3E3cTi1__"